module.exports = __webpack_public_path__ + "img/accident.3d08e236.svg";